import React from "react";
import videoBg from "../assets/Video1 - Trim.mp4";
import "./HomeStyle.css";
import { useTranslation } from "react-i18next";

const Home = ({ id }) => {
  const { t, i18n } = useTranslation();

  const scrollToConsultation = () => {
    const consultationElement = document.getElementById("consultation-form");
    if (consultationElement) {
      consultationElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main
      className={`hero-section ${i18n.language === "ar" ? "rtl-layout" : ""}`}
      id={id}
    >
      <video
        autoPlay
        muted
        loop
        className="background-video"
        playsInline
        preload="metadata"
        poster="../assets/poster.png"
        aria-label="Background introduction video for the homepage"
      >
        <source src={videoBg} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay"></div>
      <div className="content">
        <h1 className="main-title">{t("home.title")}</h1>
        <p className="sub-text">{t("home.subtitle")}</p>
        <div className="buttons">
          <button className="btnHome" onClick={scrollToConsultation}>
            {t("home.buttons.book")}
          </button>
          <a href="tel:+201026252290" className="btnHome">
            {t("home.buttons.call")}
          </a>
        </div>
      </div>
    </main>
  );
};

export default Home;
